











import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class Button extends Vue {
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
  @Prop({default:null}) public buttonStyle: string;
  @Prop({default:'right'}) public placement: string;

  public component: Components.Tooltip;
  public get isDisabled() {
    return this.disabled || !this.$api.perms.hasMenuPermission(this.perm);
  }
  public get titleSC(){
    if (this.sc==null) return this.$translate(this.caption);
    else return this.$translate(this.caption) +'('+ this.sc +')';
  }
 //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する
  public created() {
    // if (this.sc != null) document.body.addEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.add(this.sc, this.onClick);    
  }
  public mounted() {
    if(this.tooltip) this.component = this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip,this.placement);
  }

  public destroyed() {
    // if (this.sc != null) document.body.removeEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.remove(this.sc, this.onClick);    
  }

  @Watch('tooltip')
  public tooltipChanged(newValue:string, oldValue:string){
    if (this.tooltip) {
        if (this.component) this.component.title = this.tooltip;
        else this.component =  this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
    } else {
        if (this.component) {
          this.component.$destroy();
          this.component = null;
        }
    }
  }

  // public onKeyDown(ev: KeyboardEvent){
  //   if (ev.key == this.sc){
  //     ev.preventDefault();
  //     this.OnClick();
  //   }
  // }

  public onClick(): boolean {
    if (this.$el.parentElement && this.$el.parentElement.classList.contains('cx_appevent_enabled')) this.$api.issueGA4event(this.$route.path,this.caption);        
    // if (this.$api.perms.hasMenuPermission(this.perm) && this.enabled) {
    //   this.$emit('click');
    // }
    this.$emit('click');    
    return true;
  }

  // @Emit('click')
  // public OnClick() { }

  @Emit('mousedown')
  public onMouseDown(){}
  @Emit('mouseup')
  public onMouseUp(){}  
}
